import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BONUS_TOTAL, PRODUCT, bonuses } from '../data/poolContent';
export function BonusesSection() {
  return <section className="w-full bg-abyss-900 py-14 sm:py-20" aria-labelledby="bonuses-title" data-id="element-34" data-mp="gxq7lr5hj8q2">
      <div className="mx-auto max-w-6xl px-5" data-id="element-35" data-mp="vqtbwwu2fpyu">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-36" data-mp="qtjqrtdpm0gt">
          Included free with your purchase
        </p>
        <h2 id="bonuses-title" className="mt-3 text-center font-display text-[2.2rem] font-bold uppercase leading-none text-frost-50 sm:text-[3.2rem]" data-id="element-37" data-mp="14rhqbsndfsc9">
          And we didn’t stop at the water.
        </h2>
        <p className="mt-4 text-center text-[15px] leading-snug text-body" data-id="element-38" data-mp="19jreb34xeibw">
          Because owning a pool involves more than chemistry.
        </p>

        <ul className="mt-12 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-39" data-mp="1nkbvjuv7063a">
          {bonuses.map(b => <li key={b.number} className="flex flex-col" data-id="element-40" data-mp="1jgnp5fiargjm">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="mx-auto w-full max-w-[14rem] object-contain" width={1080} height={1350} loading="lazy" data-id="element-41" data-mp="3prn3xvgdv51q" />
              <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-42" data-mp="7kyyu5lc2hw2">
                Bonus #{b.number}
              </p>
              <h3 className="mt-1 min-h-[2.2em] font-display text-[1.4rem] font-bold uppercase leading-[1.05] text-frost-50" data-id="element-43" data-mp="chpe4qpbd9gf">
                {b.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-snug text-body" data-id="element-44" data-mp="lcndafj21ig7">{b.subtitle}</p>

              <ul className="mt-4 space-y-1.5" data-id="element-45" data-mp="q9vkjl2o022o">
                {b.benefits.map(benefit => <li key={benefit} className="flex items-start gap-2" data-id="element-46" data-mp="vbcnrn8mg0mf">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-aqua" strokeWidth={2.5} aria-hidden="true" data-id="element-47" data-mp="108uur832w5rs" />
                    <span className="text-[13.5px] leading-snug text-frost-100" data-id="element-48" data-mp="5mxd6nqkzmw3">{benefit}</span>
                  </li>)}
              </ul>

              <p className="mt-auto flex items-center gap-3 border-t border-abyss-600 pt-4 text-[11px] font-semibold uppercase tracking-[0.14em]" data-id="element-49" data-mp="kd4z5dfsro1j">
                <span className="text-muted" data-id="element-50" data-mp="taxdofdp2rnv">
                  Value: <span className="line-through" data-id="element-51" data-mp="tdjlmg4hz96m">{b.value}</span>
                </span>
                <span className="text-aqua" data-id="element-52" data-mp="ocdo84zw6xqr">Included free</span>
              </p>
            </li>)}
        </ul>

        <div className="mt-12 flex flex-col items-center justify-center gap-2 border-y border-gold/30 py-6 text-center sm:flex-row sm:gap-6" data-id="element-53" data-mp="yatk0l9v6v6l">
          <p className="font-display text-[1.6rem] font-bold uppercase text-gold" data-id="element-54" data-mp="352aqzvbztv9c">
            {BONUS_TOTAL} in bonus guides
          </p>
          <span className="hidden text-gold/50 sm:inline" aria-hidden="true" data-id="element-55" data-mp="3049clnpiik47">
            →
          </span>
          <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-frost-100" data-id="element-56" data-mp="1fmi02fo7vw18">
            Today: included with {PRODUCT}
          </p>
        </div>
      </div>
    </section>;
}